import { useState } from "react";
import { Platform, View } from "react-native";
import Svg, {
  Defs,
  G,
  Image as SvgImage,
  Path,
  Pattern,
} from "react-native-svg";

import { US_STATE_PATHS } from "./USStateCoverageMapPaths";

const selectedStateTexture =
  require("@src/apps/moon/assets/images/care-hero-glow-gradient.png") as number;
const MAP_UNSELECTED_FILL = "rgba(255, 255, 255, 0.12)";
const MAP_HOVER_FILL = "rgba(139, 58, 26, 0.24)";
const MAP_HOVER_STROKE = "rgba(110, 93, 82, 0.56)";

export default function USStateCoverageMap({
  selectedStateCode,
  onSelect,
}: {
  selectedStateCode: string | null;
  onSelect: (stateCode: string) => void;
}) {
  const [hoveredStateCode, setHoveredStateCode] = useState<string | null>(null);

  return (
    <View
      accessibilityLabel="Interactive United States state coverage map"
      style={{
        width: "100%",
        aspectRatio: 959 / 593,
        overflow: "visible",
      }}
    >
      <Svg
        viewBox="0 0 959 593"
        preserveAspectRatio="xMidYMid meet"
        style={{ width: "100%", height: "100%" }}
      >
        <Defs>
          <Pattern
            id="selectedStateTexture"
            patternUnits="objectBoundingBox"
            patternContentUnits="objectBoundingBox"
            x="0"
            y="0"
            width="1"
            height="1"
          >
            <SvgImage
              href={selectedStateTexture}
              x="0"
              y="0"
              width="1"
              height="1"
              preserveAspectRatio="none"
            />
          </Pattern>
        </Defs>
        {Object.entries(US_STATE_PATHS).map(([stateCode, path]) => {
          const isSelected = stateCode === selectedStateCode;
          const isHovered = stateCode === hoveredStateCode;
          return (
            <G
              key={stateCode}
              accessibilityLabel={`Show ${stateCode} state coverage`}
              onPress={() => onSelect(stateCode)}
              style={
                Platform.OS === "web"
                  ? ({ cursor: "pointer" } as Record<string, string>)
                  : undefined
              }
              {...(Platform.OS === "web"
                ? ({
                    onMouseEnter: () => setHoveredStateCode(stateCode),
                    onMouseLeave: () => setHoveredStateCode(null),
                  } as Record<string, unknown>)
                : {})}
            >
              <Path
                d={path}
                fill={
                  isSelected
                    ? "url(#selectedStateTexture)"
                    : isHovered
                      ? MAP_HOVER_FILL
                      : MAP_UNSELECTED_FILL
                }
                stroke={
                  isSelected
                    ? "rgba(255, 255, 255, 0.72)"
                    : isHovered
                      ? MAP_HOVER_STROKE
                      : "rgba(110, 93, 82, 0.24)"
                }
                strokeWidth={isSelected ? 2.25 : isHovered ? 2 : 1.25}
                strokeLinejoin="round"
                opacity={isSelected || isHovered ? 1 : 0.92}
              />
            </G>
          );
        })}
      </Svg>
    </View>
  );
}
